import PropTypes from 'prop-types'
import { Box, MenuItem } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import DatePicker from '../../../ui/components/datePicker'
import Select from '../../../ui/components/select'

import { DATE_TYPES_MAP } from '../index'

import styles from './styles'

const propTypes = {
  clientCenterCode: PropTypes.string,
  clientCenterCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectClientCenterCode: PropTypes.func.isRequired,
  selectDate: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
}

const FiltersView = ({
  clientCenterCodes,
  selectClientCenterCode,
  selectDate,
  startDate,
  endDate,
  clientCenterCode,
}) => {
  const formatMessage = useTranslations()

  const handleDateChange = (date, dateType) => {
    selectDate(date, dateType)
  }

  const handleClientCenterCodeChange = event => {
    const selectedCenter = event.target.value
    selectClientCenterCode(selectedCenter)
  }

  return (
    <Box sx={styles.fieldsWrapper}>
      <Select
        labelId={'filter-client-center'}
        label={formatMessage('billing:filter-client-center')}
        value={
          clientCenterCode ? clientCenterCode : formatMessage('message:loading')
        }
        sx={styles.selectField}
        onChange={handleClientCenterCodeChange}
      >
        {clientCenterCodes.length > 0 ? (
          clientCenterCodes.map(center => (
            <MenuItem key={center} value={center}>
              {center}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled value={formatMessage('message:loading')}>
            <em>{formatMessage('message:loading')}</em>
          </MenuItem>
        )}
      </Select>
      <DatePicker
        label={formatMessage('noun:from')}
        placeholder="dd/mm/aaaa"
        inputFormat="dd/MM/yyyy"
        error={false}
        value={startDate}
        onChange={date => {
          handleDateChange(date, DATE_TYPES_MAP.start)
        }}
        sx={styles.datePickerField}
      />
      <DatePicker
        label={formatMessage('noun:to')}
        placeholder="dd/mm/aaaa"
        inputFormat="dd/MM/yyyy"
        error={false}
        value={endDate}
        onChange={date => {
          handleDateChange(date, DATE_TYPES_MAP.end)
        }}
        sx={styles.datePickerField}
      />
    </Box>
  )
}

FiltersView.propTypes = propTypes

export default FiltersView
